import mitt from "mitt";

//@Reference: https://github.com/developit/mitt
export default mitt();
